import * as Sentry from '@sentry/browser';

const { MODE, VITE_SENTRY_DSN } = import.meta.env;

// ATTENTION:
// import.meta.env.RAILS_ENV は、本番環境などで取得すると "production" と
// ダブルクォーテーションで括られた文字列が出力される。（testingも同様）
if (MODE === 'testing' || MODE === 'production') {
  Sentry.init({
    dsn: VITE_SENTRY_DSN,

    environment: MODE,

    sampleRate: 1.0,

    tracesSampleRate: MODE === 'production' ? 0.05 : 0.2,

    replaysSessionSampleRate: MODE === 'production' ? 0.01 : 0,

    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  });
}
